var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.emailEnabled
    ? _c("div", [
        !_vm.isEmailSet
          ? _c("p", [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.t(
                      "activity",
                      "You need to set up your email address before you can receive notification emails."
                    )
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("p", [
          _c(
            "label",
            {
              staticClass: "activity-frequency__label",
              attrs: { for: "activity_setting_batchtime" },
            },
            [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm.t("activity", "Send activity emails")) +
                  "\n\t\t"
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              staticClass: "notification-frequency__select",
              attrs: { name: "notify_setting_batchtime" },
              on: {
                change: function ($event) {
                  return _vm.setSettingBatchtime({
                    settingBatchtime: $event.target.value,
                  })
                },
              },
            },
            [
              _c(
                "option",
                {
                  domProps: {
                    value: _vm.EmailFrequency.EMAIL_SEND_ASAP,
                    selected:
                      _vm.settingBatchtime ===
                      _vm.EmailFrequency.EMAIL_SEND_ASAP,
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.t("activity", "As soon as possible")) +
                      "\n\t\t\t"
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "option",
                {
                  domProps: {
                    value: _vm.EmailFrequency.EMAIL_SEND_HOURLY,
                    selected:
                      _vm.settingBatchtime ===
                      _vm.EmailFrequency.EMAIL_SEND_HOURLY,
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.t("activity", "Hourly")) +
                      "\n\t\t\t"
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "option",
                {
                  domProps: {
                    value: _vm.EmailFrequency.EMAIL_SEND_DAILY,
                    selected:
                      _vm.settingBatchtime ===
                      _vm.EmailFrequency.EMAIL_SEND_DAILY,
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.t("activity", "Daily")) +
                      "\n\t\t\t"
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "option",
                {
                  domProps: {
                    value: _vm.EmailFrequency.EMAIL_SEND_WEEKLY,
                    selected:
                      _vm.settingBatchtime ===
                      _vm.EmailFrequency.EMAIL_SEND_WEEKLY,
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.t("activity", "Weekly")) +
                      "\n\t\t\t"
                  ),
                ]
              ),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }